// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile-module__font-s-10___rnEsJ {
  font-size: 10px !important;
}

.Profile-module__font-s-12___e6ubT {
  font-size: 12px !important;
}

.Profile-module__font-s-13___dRl31 {
  font-size: 13px !important;
}

.Profile-module__font-s-14___qbaCk {
  font-size: 14px !important;
}

.Profile-module__font-s-15___ZmfPT {
  font-size: 15px !important;
}

.Profile-module__font-s-16___v_cDx {
  font-size: 16px !important;
}

.Profile-module__font-s-18___TjWYi {
  font-size: 18px !important;
}

.Profile-module__font-s-20___tmkf3 {
  font-size: 20px !important;
}

.Profile-module__font-s-22___WDzgs {
  font-size: 22px !important;
}

.Profile-module__font-s-28___mNALr {
  font-size: 28px !important;
}

.Profile-module__font-w-400___KezLU {
  font-weight: 400 !important;
}

.Profile-module__font-w-500___O_P0H {
  font-weight: 500 !important;
}

.Profile-module__font-w-600___lnuA6 {
  font-weight: 600 !important;
}

.Profile-module__font-w-700___RKEsi {
  font-weight: 700 !important;
}

.Profile-module__p-5___t39Cc {
  padding: 5px !important;
}

.Profile-module__p-12___iEyu9 {
  padding: 12px !important;
}

.Profile-module__p-16___LKDXX {
  padding: 16px !important;
}

.Profile-module__p-30___XG8jQ {
  padding: 30px !important;
}

.Profile-module__p-b-0___p14vk {
  padding-bottom: 0 !important;
}

.Profile-module__p-b-5___m6gOx {
  padding-bottom: 5px !important;
}

.Profile-module__p-b-10___NcbjA {
  padding-bottom: 10px !important;
}

.Profile-module__p-b-12___L510W {
  padding-bottom: 12px !important;
}

.Profile-module__p-b-16___pq6_S {
  padding-bottom: 16px !important;
}

.Profile-module__p-b-18___NvZIF {
  padding-bottom: 18px !important;
}

.Profile-module__p-b-20___t5Bbk {
  padding-bottom: 20px !important;
}

.Profile-module__p-b-25___letx4 {
  padding-bottom: 25px !important;
}

.Profile-module__p-b-30___1_EEn {
  padding-bottom: 30px !important;
}

.Profile-module__p-b-50___wmLtq {
  padding-bottom: 50px !important;
}

.Profile-module__p-t-0___moMd_ {
  padding-top: 0 !important;
}

.Profile-module__p-t-12___qn1AU {
  padding-top: 12px !important;
}

.Profile-module__p-t-16___WSQOM {
  padding-top: 16px !important;
}

.Profile-module__p-t-18___diZYX {
  padding-top: 18px !important;
}

.Profile-module__p-t-20___Gxvxz {
  padding-top: 20px !important;
}

.Profile-module__p-t-30___kX1UR {
  padding-top: 30px !important;
}

.Profile-module__p-t-40___wAwu6 {
  padding-top: 40px !important;
}

.Profile-module__p-t-50___zmpyo {
  padding-top: 50px !important;
}

.Profile-module__p-l-20___zrACw {
  padding-left: 20px !important;
}

.Profile-module__p-l-30___YRhG7 {
  padding-left: 30px !important;
}

.Profile-module__p-l-40___UybzK {
  padding-left: 40px !important;
}

.Profile-module__p-r-16___jIEtH {
  padding-right: 16px !important;
}

.Profile-module__p-r-20___nTmPp {
  padding-right: 20px !important;
}

.Profile-module__p-r-30___zbCH4 {
  padding-right: 30px !important;
}

.Profile-module__p-r-50___qDLkb {
  padding-right: 50px !important;
}

.Profile-module__p-r-60___b7TsJ {
  padding-right: 60px !important;
}

.Profile-module__m-b-1___WD0H4 {
  margin-bottom: 1px !important;
}

.Profile-module__m-b-2___dggk2 {
  margin-bottom: 2px !important;
}

.Profile-module__m-b-6___jxqHV {
  margin-bottom: 6px !important;
}

.Profile-module__m-b-8___n2PCN {
  margin-bottom: 8px !important;
}

.Profile-module__m-b-10___W73PU {
  margin-bottom: 10px !important;
}

.Profile-module__m-b-14___aj4pi {
  margin-bottom: 14px !important;
}

.Profile-module__m-b-16___DLIpM {
  margin-bottom: 16px !important;
}

.Profile-module__m-b-20___Ib0YB {
  margin-bottom: 20px !important;
}

.Profile-module__m-b-22___pZIqR {
  margin-bottom: 22px !important;
}

.Profile-module__m-b-24___w5gbB {
  margin-bottom: 24px !important;
}

.Profile-module__m-b-30___rxZCf {
  margin-bottom: 30px !important;
}

.Profile-module__m-b-32___HaK6w {
  margin-bottom: 32px !important;
}

.Profile-module__m-b-40___bi8fU {
  margin-bottom: 40px !important;
}

.Profile-module__m-t-2___pFhX7 {
  margin-top: 2px !important;
}

.Profile-module__m-t-3___G6KJu {
  margin-top: 3px !important;
}

.Profile-module__m-t-4___I6eVr {
  margin-top: 4px !important;
}

.Profile-module__m-t-5___F5Oyc {
  margin-top: 5px !important;
}

.Profile-module__m-t-8___UdHft {
  margin-top: 8px !important;
}

.Profile-module__m-t-10___zJH_u {
  margin-top: 10px !important;
}

.Profile-module__m-t-15___srfB1 {
  margin-top: 15px !important;
}

.Profile-module__m-t-16___RnpJX {
  margin-top: 16px !important;
}

.Profile-module__m-t-20___t7s5k {
  margin-top: 20px !important;
}

.Profile-module__m-t-22___UXKNE {
  margin-top: 22px !important;
}

.Profile-module__m-t-30___gJleX {
  margin-top: 30px !important;
}

.Profile-module__m-t-32___IiYxz {
  margin-top: 32px !important;
}

.Profile-module__m-l-auto____jFZS {
  margin-left: auto !important;
}

.Profile-module__m-l-4___pkDPP {
  margin-left: 4px !important;
}

.Profile-module__m-l-5___WEbs5 {
  margin-left: 5px !important;
}

.Profile-module__m-l-6___iZTTL {
  margin-left: 6px !important;
}

.Profile-module__m-l-8___V9jup {
  margin-left: 8px !important;
}

.Profile-module__m-l-10___hEgnv {
  margin-left: 10px !important;
}

.Profile-module__m-l-16___jhJZg {
  margin-left: 16px !important;
}

.Profile-module__m-l-20___Bs0Ge {
  margin-left: 20px !important;
}

.Profile-module__m-l-24___mS6dA {
  margin-left: 24px !important;
}

.Profile-module__m-l-30___OnNpM {
  margin-left: 30px !important;
}

.Profile-module__m-l-35___chO5N {
  margin-left: 35px !important;
}

.Profile-module__m-l-40___XPKBB {
  margin-left: 40px !important;
}

.Profile-module__m-r-8___TkZgg {
  margin-right: 8px !important;
}

.Profile-module__m-r-10___omKZ1 {
  margin-right: 10px !important;
}

.Profile-module__m-r-16___aT4Sc {
  margin-right: 16px !important;
}

.Profile-module__m-r-20___QKwzh {
  margin-right: 20px !important;
}

.Profile-module__m-r-24___daMjv {
  margin-right: 24px !important;
}

.Profile-module__m-r-30___cOcL1 {
  margin-right: 30px !important;
}

.Profile-module__m-r-40___VfqGs {
  margin-right: 40px !important;
}

.Profile-module__border-r-3___GUNrS {
  border-radius: 3px !important;
}

.Profile-module__border-r-4___dbEmq {
  border-radius: 4px !important;
}

.Profile-module__border-r-6___HlXCL {
  border-radius: 6px !important;
}

.Profile-module__border-r-10___tZAe5 {
  border-radius: 10px !important;
}

.Profile-module__border-r-12___uyz8y {
  border-radius: 12px !important;
}

.Profile-module__border-r-16___ItC64 {
  border-radius: 16px !important;
}

.Profile-module__border-r-50___KvtE6 {
  border-radius: 50% !important;
}

.Profile-module__primary-border___aF5MU {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Profile-module__primary-border-b___lpHb4 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Profile-module__primary-border-t___t2CCn {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Profile-module__primary-border-l___BySu4 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Profile-module__primary-border-r___ACk8R {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Profile-module__secondary-border___MQVJw {
  border: 1px solid #637768;
}

.Profile-module__secondary-border-b___MupjD {
  border-bottom: 1px solid #637768;
}

.Profile-module__secondary-border-t___NBLeC {
  border-top: 1px solid #637768;
}

.Profile-module__secondary-border-l___ipiyK {
  border-left: 1px solid #637768;
}

.Profile-module__secondary-border-r___EmAIh {
  border-right: 1px solid #637768;
}

.Profile-module__gap-0___NleaT {
  gap: 0 !important;
}

.Profile-module__gap-2___GcrN6 {
  gap: 2px !important;
}

.Profile-module__gap-4___RoePs {
  gap: 4px !important;
}

.Profile-module__gap-5___e8e2n {
  gap: 5px !important;
}

.Profile-module__gap-6___uSQ3Z {
  gap: 6px !important;
}

.Profile-module__gap-8___BokSp {
  gap: 8px !important;
}

.Profile-module__gap-10___kdTJU {
  gap: 10px !important;
}

.Profile-module__gap-12___LvrRb {
  gap: 12px !important;
}

.Profile-module__gap-14___SC7oM {
  gap: 14px !important;
}

.Profile-module__gap-16___kd471 {
  gap: 16px !important;
}

.Profile-module__gap-18___Wf7uP {
  gap: 18px !important;
}

.Profile-module__gap-20___Jo8Gn {
  gap: 20px !important;
}

.Profile-module__gap-24___IpV_B {
  gap: 24px !important;
}

.Profile-module__gap-26___ZDPbQ {
  gap: 26px !important;
}

.Profile-module__gap-30___TYbon {
  gap: 30px !important;
}

.Profile-module__gap-32___cx0hC {
  gap: 32px !important;
}

.Profile-module__gap-40___AWEbF {
  gap: 40px !important;
}

.Profile-module__gap-50___LEUCk {
  gap: 50px !important;
}

.Profile-module__flex-1___VGhbM {
  flex: 1;
}

.Profile-module__flex-none___ldIna {
  flex: none !important;
}

.Profile-module__flex-column___tpeEV {
  display: flex;
  flex-direction: column !important;
}

.Profile-module__flex-row___NGWtP {
  display: flex;
  flex-direction: row !important;
}

.Profile-module__vertically-centered___ZJXwt {
  display: flex;
  align-items: center !important;
}

.Profile-module__horizontally-centered___BnG4j {
  display: flex;
  justify-content: center !important;
}

.Profile-module__horizontally-end___FivfC {
  display: flex;
  justify-content: end !important;
}

.Profile-module__vertically-start___pQAZ8 {
  display: flex;
  align-items: start !important;
}

.Profile-module__space-between___Vj6kl {
  display: flex;
  justify-content: space-between !important;
}

.Profile-module__flex-wrap___tzmKs {
  flex-wrap: wrap !important;
}

.Profile-module__height-100___vZkJr {
  height: 100%;
}

.Profile-module__width-50___KCBm2 {
  width: 50% !important;
}

.Profile-module__width-100___QKXjr {
  width: 100%;
}

.Profile-module__cursor-pointer___KmaKF {
  cursor: pointer;
}

.Profile-module__cursor-not-allowed___PC9Wc {
  cursor: not-allowed !important;
}

.Profile-module__absolute-centered___XDDYH {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Profile-module__absolute___HyAzb {
  position: absolute;
}

.Profile-module__relative___CoaQN {
  position: relative;
}

.Profile-module__fixed___UGdPc {
  position: fixed;
}

.Profile-module__visible___SdiNF {
  opacity: 1;
}

.Profile-module__invisible___DM3bC {
  opacity: 0;
}

.Profile-module__col-90___xtL3S {
  width: 90% !important;
}

.Profile-module__col-auto___yDCLn {
  width: auto !important;
}

.Profile-module__medical-tabs___rYT9F {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Profile-module__medical-table-new___M5Neg {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Profile-module__medical-table-new___M5Neg:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Profile-module__medical-table-new___M5Neg::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Profile-module__medical-table-new___M5Neg::-webkit-scrollbar-track {
  display: none;
}
.Profile-module__medical-table-new___M5Neg.Profile-module__no-pagination___D_7sB {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Profile-module__medical-table-new___M5Neg.Profile-module__no-pagination___D_7sB:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Profile-module__medical-table-new___M5Neg.Profile-module__no-pagination___D_7sB::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Profile-module__medical-table-new___M5Neg.Profile-module__no-pagination___D_7sB::-webkit-scrollbar-track {
  display: none;
}

.Profile-module__medical-table-empty___UWtlT {
  padding: 14px 40px !important;
}

.Profile-module__icon-btn___NoTmq {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Profile-module__search-icon___S9EDS {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Profile-module__disable-select___rCadd {
  user-select: none;
}

.Profile-module__break-word___UWoIH {
  word-break: break-word;
}

.Profile-module__popup-clear-btn___MSW8L {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Profile-module__scroll-m-b-20___RHuMK {
  scroll-margin-bottom: 20px;
}

.Profile-module__article___Xi96J {
  display: grid;
  column-gap: 16px;
  padding: 27px 10% 27px 24px;
  grid-template-columns: 3fr 1fr;
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Profile-module__article___Xi96J:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Profile-module__article___Xi96J::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Profile-module__article___Xi96J::-webkit-scrollbar-track {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Profile/Profile.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;ECIA,2GDFE;ECGF,kBAAA;EACA,kBAAA;AD2pBF;ACzpBE;EACE,oCAAA;EACA,mBAAA;AD2pBJ;ACxpBE;EACE,UAAA;EACA,6BAAA;AD0pBJ;ACvpBE;EACE,aAAA;ADypBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.article {\n  display: grid;\n  column-gap: 16px;\n  padding: 27px 10% 27px 24px;\n  grid-template-columns: 3fr 1fr;\n  @include verticalScroll(\n    calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer)\n    )\n  );\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Profile-module__font-s-10___rnEsJ`,
	"fontS12": `Profile-module__font-s-12___e6ubT`,
	"fontS13": `Profile-module__font-s-13___dRl31`,
	"fontS14": `Profile-module__font-s-14___qbaCk`,
	"fontS15": `Profile-module__font-s-15___ZmfPT`,
	"fontS16": `Profile-module__font-s-16___v_cDx`,
	"fontS18": `Profile-module__font-s-18___TjWYi`,
	"fontS20": `Profile-module__font-s-20___tmkf3`,
	"fontS22": `Profile-module__font-s-22___WDzgs`,
	"fontS28": `Profile-module__font-s-28___mNALr`,
	"fontW400": `Profile-module__font-w-400___KezLU`,
	"fontW500": `Profile-module__font-w-500___O_P0H`,
	"fontW600": `Profile-module__font-w-600___lnuA6`,
	"fontW700": `Profile-module__font-w-700___RKEsi`,
	"p5": `Profile-module__p-5___t39Cc`,
	"p12": `Profile-module__p-12___iEyu9`,
	"p16": `Profile-module__p-16___LKDXX`,
	"p30": `Profile-module__p-30___XG8jQ`,
	"pB0": `Profile-module__p-b-0___p14vk`,
	"pB5": `Profile-module__p-b-5___m6gOx`,
	"pB10": `Profile-module__p-b-10___NcbjA`,
	"pB12": `Profile-module__p-b-12___L510W`,
	"pB16": `Profile-module__p-b-16___pq6_S`,
	"pB18": `Profile-module__p-b-18___NvZIF`,
	"pB20": `Profile-module__p-b-20___t5Bbk`,
	"pB25": `Profile-module__p-b-25___letx4`,
	"pB30": `Profile-module__p-b-30___1_EEn`,
	"pB50": `Profile-module__p-b-50___wmLtq`,
	"pT0": `Profile-module__p-t-0___moMd_`,
	"pT12": `Profile-module__p-t-12___qn1AU`,
	"pT16": `Profile-module__p-t-16___WSQOM`,
	"pT18": `Profile-module__p-t-18___diZYX`,
	"pT20": `Profile-module__p-t-20___Gxvxz`,
	"pT30": `Profile-module__p-t-30___kX1UR`,
	"pT40": `Profile-module__p-t-40___wAwu6`,
	"pT50": `Profile-module__p-t-50___zmpyo`,
	"pL20": `Profile-module__p-l-20___zrACw`,
	"pL30": `Profile-module__p-l-30___YRhG7`,
	"pL40": `Profile-module__p-l-40___UybzK`,
	"pR16": `Profile-module__p-r-16___jIEtH`,
	"pR20": `Profile-module__p-r-20___nTmPp`,
	"pR30": `Profile-module__p-r-30___zbCH4`,
	"pR50": `Profile-module__p-r-50___qDLkb`,
	"pR60": `Profile-module__p-r-60___b7TsJ`,
	"mB1": `Profile-module__m-b-1___WD0H4`,
	"mB2": `Profile-module__m-b-2___dggk2`,
	"mB6": `Profile-module__m-b-6___jxqHV`,
	"mB8": `Profile-module__m-b-8___n2PCN`,
	"mB10": `Profile-module__m-b-10___W73PU`,
	"mB14": `Profile-module__m-b-14___aj4pi`,
	"mB16": `Profile-module__m-b-16___DLIpM`,
	"mB20": `Profile-module__m-b-20___Ib0YB`,
	"mB22": `Profile-module__m-b-22___pZIqR`,
	"mB24": `Profile-module__m-b-24___w5gbB`,
	"mB30": `Profile-module__m-b-30___rxZCf`,
	"mB32": `Profile-module__m-b-32___HaK6w`,
	"mB40": `Profile-module__m-b-40___bi8fU`,
	"mT2": `Profile-module__m-t-2___pFhX7`,
	"mT3": `Profile-module__m-t-3___G6KJu`,
	"mT4": `Profile-module__m-t-4___I6eVr`,
	"mT5": `Profile-module__m-t-5___F5Oyc`,
	"mT8": `Profile-module__m-t-8___UdHft`,
	"mT10": `Profile-module__m-t-10___zJH_u`,
	"mT15": `Profile-module__m-t-15___srfB1`,
	"mT16": `Profile-module__m-t-16___RnpJX`,
	"mT20": `Profile-module__m-t-20___t7s5k`,
	"mT22": `Profile-module__m-t-22___UXKNE`,
	"mT30": `Profile-module__m-t-30___gJleX`,
	"mT32": `Profile-module__m-t-32___IiYxz`,
	"mLAuto": `Profile-module__m-l-auto____jFZS`,
	"mL4": `Profile-module__m-l-4___pkDPP`,
	"mL5": `Profile-module__m-l-5___WEbs5`,
	"mL6": `Profile-module__m-l-6___iZTTL`,
	"mL8": `Profile-module__m-l-8___V9jup`,
	"mL10": `Profile-module__m-l-10___hEgnv`,
	"mL16": `Profile-module__m-l-16___jhJZg`,
	"mL20": `Profile-module__m-l-20___Bs0Ge`,
	"mL24": `Profile-module__m-l-24___mS6dA`,
	"mL30": `Profile-module__m-l-30___OnNpM`,
	"mL35": `Profile-module__m-l-35___chO5N`,
	"mL40": `Profile-module__m-l-40___XPKBB`,
	"mR8": `Profile-module__m-r-8___TkZgg`,
	"mR10": `Profile-module__m-r-10___omKZ1`,
	"mR16": `Profile-module__m-r-16___aT4Sc`,
	"mR20": `Profile-module__m-r-20___QKwzh`,
	"mR24": `Profile-module__m-r-24___daMjv`,
	"mR30": `Profile-module__m-r-30___cOcL1`,
	"mR40": `Profile-module__m-r-40___VfqGs`,
	"borderR3": `Profile-module__border-r-3___GUNrS`,
	"borderR4": `Profile-module__border-r-4___dbEmq`,
	"borderR6": `Profile-module__border-r-6___HlXCL`,
	"borderR10": `Profile-module__border-r-10___tZAe5`,
	"borderR12": `Profile-module__border-r-12___uyz8y`,
	"borderR16": `Profile-module__border-r-16___ItC64`,
	"borderR50": `Profile-module__border-r-50___KvtE6`,
	"primaryBorder": `Profile-module__primary-border___aF5MU`,
	"primaryBorderB": `Profile-module__primary-border-b___lpHb4`,
	"primaryBorderT": `Profile-module__primary-border-t___t2CCn`,
	"primaryBorderL": `Profile-module__primary-border-l___BySu4`,
	"primaryBorderR": `Profile-module__primary-border-r___ACk8R`,
	"secondaryBorder": `Profile-module__secondary-border___MQVJw`,
	"secondaryBorderB": `Profile-module__secondary-border-b___MupjD`,
	"secondaryBorderT": `Profile-module__secondary-border-t___NBLeC`,
	"secondaryBorderL": `Profile-module__secondary-border-l___ipiyK`,
	"secondaryBorderR": `Profile-module__secondary-border-r___EmAIh`,
	"gap0": `Profile-module__gap-0___NleaT`,
	"gap2": `Profile-module__gap-2___GcrN6`,
	"gap4": `Profile-module__gap-4___RoePs`,
	"gap5": `Profile-module__gap-5___e8e2n`,
	"gap6": `Profile-module__gap-6___uSQ3Z`,
	"gap8": `Profile-module__gap-8___BokSp`,
	"gap10": `Profile-module__gap-10___kdTJU`,
	"gap12": `Profile-module__gap-12___LvrRb`,
	"gap14": `Profile-module__gap-14___SC7oM`,
	"gap16": `Profile-module__gap-16___kd471`,
	"gap18": `Profile-module__gap-18___Wf7uP`,
	"gap20": `Profile-module__gap-20___Jo8Gn`,
	"gap24": `Profile-module__gap-24___IpV_B`,
	"gap26": `Profile-module__gap-26___ZDPbQ`,
	"gap30": `Profile-module__gap-30___TYbon`,
	"gap32": `Profile-module__gap-32___cx0hC`,
	"gap40": `Profile-module__gap-40___AWEbF`,
	"gap50": `Profile-module__gap-50___LEUCk`,
	"flex1": `Profile-module__flex-1___VGhbM`,
	"flexNone": `Profile-module__flex-none___ldIna`,
	"flexColumn": `Profile-module__flex-column___tpeEV`,
	"flexRow": `Profile-module__flex-row___NGWtP`,
	"verticallyCentered": `Profile-module__vertically-centered___ZJXwt`,
	"horizontallyCentered": `Profile-module__horizontally-centered___BnG4j`,
	"horizontallyEnd": `Profile-module__horizontally-end___FivfC`,
	"verticallyStart": `Profile-module__vertically-start___pQAZ8`,
	"spaceBetween": `Profile-module__space-between___Vj6kl`,
	"flexWrap": `Profile-module__flex-wrap___tzmKs`,
	"height100": `Profile-module__height-100___vZkJr`,
	"width50": `Profile-module__width-50___KCBm2`,
	"width100": `Profile-module__width-100___QKXjr`,
	"cursorPointer": `Profile-module__cursor-pointer___KmaKF`,
	"cursorNotAllowed": `Profile-module__cursor-not-allowed___PC9Wc`,
	"absoluteCentered": `Profile-module__absolute-centered___XDDYH`,
	"absolute": `Profile-module__absolute___HyAzb`,
	"relative": `Profile-module__relative___CoaQN`,
	"fixed": `Profile-module__fixed___UGdPc`,
	"visible": `Profile-module__visible___SdiNF`,
	"invisible": `Profile-module__invisible___DM3bC`,
	"col90": `Profile-module__col-90___xtL3S`,
	"colAuto": `Profile-module__col-auto___yDCLn`,
	"medicalTabs": `Profile-module__medical-tabs___rYT9F`,
	"medicalTableNew": `Profile-module__medical-table-new___M5Neg`,
	"noPagination": `Profile-module__no-pagination___D_7sB`,
	"medicalTableEmpty": `Profile-module__medical-table-empty___UWtlT`,
	"iconBtn": `Profile-module__icon-btn___NoTmq`,
	"searchIcon": `Profile-module__search-icon___S9EDS`,
	"disableSelect": `Profile-module__disable-select___rCadd`,
	"breakWord": `Profile-module__break-word___UWoIH`,
	"popupClearBtn": `Profile-module__popup-clear-btn___MSW8L`,
	"scrollMB20": `Profile-module__scroll-m-b-20___RHuMK`,
	"article": `Profile-module__article___Xi96J`
};
module.exports = ___CSS_LOADER_EXPORT___;
